import { useQuery } from "react-query";
import { InvoiceRequest } from "../../../../apis/invoice/InvoiceRequest";
import LocalStorage from "../../../../config/LocalStorage";

const GetInvoiceHistoryId = (id: number) => {
  const role = LocalStorage.ROLE || localStorage.getItem("ROLE") || "admin";
  const { data, isLoading } = useQuery([`GetInvoiceHistoryId-${id}`], () =>
    InvoiceRequest.getInvoiceWaitingById(id, role)
  );
  return {
    data,
    isLoading,
  };
};

export default GetInvoiceHistoryId;
